import React from "react";
import { cleanJoin } from "../../utils/stringUtil";

function LevelSide({ align, className, children, ...rest }) {
  return (
    <div className={cleanJoin("level-" + align, className)} {...rest}>
      {children}
    </div>
  );
}

export default LevelSide;
